import React, { useState, useEffect, useContext } from 'react';
import AppContext from 'context/Context';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import FindAUserForm from './FindAUserForm';
import { removeEmptyFromObj } from 'utils/functions';
import { userAPI } from 'utils/api/fulcrum-api';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import moment from 'moment';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';

const columns = [
	{
		accessor: 'first_name',
		Header: 'First Name',
		headerProps: { className: 'pe-1' },
		cellProps: {
			className: 'py-2'
		}
	},
	{
		accessor: 'last_name',
		Header: 'Last Name',
		headerProps: { className: 'pe-1' },
		cellProps: {
			className: 'py-2'
		}
	},
	{
		accessor: 'user_type',
		Header: 'User Type',
		headerProps: { className: 'pe-1' },
		cellProps: {
			className: 'py-2'
		}
	},
	{
		accessor: 'action',
		Header: 'Action',
		headerProps: { className: 'pe-1' },
		cellProps: {
			className: 'py-2'
		}
	}
];

function BulAction({ selectedRowIds, handleMultiUserSelection = () => { } }) {
	return (
		<Row className="flex-between-center mb-3">
			<Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
				<h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
					{
						Object.keys(selectedRowIds).length > 0 ?
							'You have selected ' + Object.keys(selectedRowIds).length + ' rows'
							:
							'Select a user'
					}
				</h5>
			</Col>
			<Col xs={8} sm="auto" className="ms-auto text-end ps-0">
				{Object.keys(selectedRowIds).length > 0 ? (
					<div className="d-flex">
						<Button
							type="button"
							variant="falcon-default"
							size="sm"
							className="ms-2"
							onClick={() => {
								console.log('selectedRowIds', selectedRowIds);
								handleMultiUserSelection(selectedRowIds);
							}}
						>
							Select All
						</Button>
					</div>
				) : (
					<div id="orders-actions">
						{/* <IconButton
							variant="falcon-default"
							size="sm"
							icon="plus"
							transform="shrink-3"
							className='me-2'
						>
							<span className="d-none d-sm-inline-block ms-1">New</span>
						</IconButton>
						<IconButton
							variant="falcon-default"
							size="sm"
							icon="external-link-alt"
							transform="shrink-3"
						>
							<span className="d-none d-sm-inline-block ms-1">Export</span>
						</IconButton> */}
					</div>
				)}
			</Col>
		</Row>
	);
};

const UserQuickFind = ({ buttonLabel = "Search Users", buttonVariant = "primary", handleUserSelection = () => { }, defaultSearchParams = {}, requiredSearchParams = {}, skipFirstQuery = true, allowMultipleSelect = true }) => {

	const {
		config: { isDark }
	} = useContext(AppContext);

	const [quickFindModalState, setQuickFindModalState] = useState(false);
	const [foundUsers, setFoundUsers] = useState([]);
	const [userCount, setUserCount] = useState(0);
	const [searchParams, setSearchParams] = useState({ ...defaultSearchParams });
	const [lastQuery, setLastQuery] = useState({});
	const [skipFirstSearch, setSkipFirstSearch] = useState(skipFirstQuery);
	const [searching, setSearching] = useState(false);



	const formatData = (data = []) => {
		let adjustedData = data.map(c => {
			return {
				...c,
				user_type: c.assigned_user_types ? (c.assigned_user_types.filter(t => t.user_type_id === "REPRESENTATIVE")?.length > 0 ? "Representative" : 'Staff') : '',
				action: (
					<Button
						variant="falcon-default"
						size="sm"
						onClick={() => handleUserSelect([c])}
					>
						Select
					</Button>
				)
			}
		});
		setFoundUsers(adjustedData);

		setSearching(false);
	};

	// Search Clients
	const handleSearch = async (params, saveLastQuery = false) => {
		try {
			params = removeEmptyFromObj(params);

			let response = await userAPI.searchUsers({ ...params });
			if (!response?.data?.rows) {
				throw new Error('No user data found');
			}
			setUserCount(response.data.count);
			formatData(response.data.rows);
			if (saveLastQuery) {
				setLastQuery(params);
			}
		} catch (error) {
			console.log(error);
		}
		setSearching(false);
	};

	// Apply search filters
	const newSearch = async (params) => {
		params = removeEmptyFromObj(params);
		setSearching(true);
		let adjustedSearchParams = {
			...params,
			...requiredSearchParams
		};
		setSkipFirstSearch(false);
		handleSearch(adjustedSearchParams);
	};

	// Refresh last query
	const refreshLastQuery = async () => {
		handleSearch({ ...lastQuery, ...requiredSearchParams });
	};

	// Handle modal close
	const handleClose = () => {
		setUserCount(0);
		setFoundUsers([]);
		setSearchParams({});
		setQuickFindModalState(false);
	};

	// Handle modal open
	const handleShow = () => {
		newSearch(searchParams);
	};

	// Handle multiple user selection
	const handleMultiUserSelection = (selectedRows = []) => {
		// loop through and grab user data by row
		let users = [];
		Object.keys(selectedRows).forEach(row => {
			users.push(foundUsers[row]);
		});
		handleUserSelect(users);
	}


	// Select a user
	const handleUserSelect = (users = [], getUsers = false) => {
		handleUserSelection(users);
		handleClose();
	};

	useEffect(() => {
		if (!skipFirstSearch) {
			if (Object.keys(searchParams).length > 0) {
				newSearch(searchParams);
			} else {
				// setSearchParams({});

				// setFoundUsers([]);
				// setUserCount(0);
				// // newSearch();
			}
		}
		setSkipFirstSearch(false);
	}, [searchParams]);


	return (
		<>
			<Button variant={buttonVariant} onClick={() => setQuickFindModalState(true)}>
				{buttonLabel}
			</Button>

			<Modal
				show={quickFindModalState}
				onHide={handleClose}
				onShow={handleShow}
				size="lg"
				backdrop="static"
				contentClassName="border"
			>
				<Modal.Header
					closeButton
					closeVariant={isDark ? 'white' : undefined}
					className="bg-light px-card border-bottom-0"
				>
					<Modal.Title as="h5">User Quick Find</Modal.Title>
				</Modal.Header>
				<Modal.Body className="p-card">
					{/* <FindAUserForm
						searchParams={searchParams}
						setSearchParams={setSearchParams}
						requiredSearchParams={requiredSearchParams}
					/> */}

					<div className="d-flex justify-content-between align-items-center mt-3">
						<h5 className="mb-0">{userCount} Found Users</h5>
						{/* <span className="text-muted">{userCount} found</span> */}
					</div>
					<div className="mt-3">
						{
							searching ?
								<p>Searching....</p>
								:
								<AdvanceTableWrapper
									columns={columns}
									data={foundUsers}
									sortable
									searchable
									pagination
									perPage={5}
									selection={allowMultipleSelect}
								>
									<BulAction table handleMultiUserSelection={handleMultiUserSelection} />
									<Row className="flex-end-center mb-3">
										<Col xs="auto" sm={6} lg={4}>
											<AdvanceTableSearchBox table />
										</Col>
									</Row>
									<AdvanceTable
										table
										headerClassName="bg-200 text-900 text-nowrap align-middle"
										rowClassName="align-middle white-space-nowrap"
										tableProps={{
											bordered: true,
											striped: true,
											className: 'fs--1 mb-0 overflow-hidden'
										}}
									/>
									<div className="mt-3">
										<AdvanceTableFooter
											rowCount={userCount}
											table
											navButtons
										/>
									</div>
								</AdvanceTableWrapper>
						}
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default UserQuickFind;